import { getLocalizedText as text } from '@vp-dst/localization-util';

export default class DesignServicesUtil {
  static getProductDesignBriefURL(options = {}) {
    const {
      productName,
      pfid,
      designLivePreSelected = false, // set the default value
    } = options;

    const productQuery = productName && pfid ? `&productName=${encodeURIComponent(productName)}&pfid=${encodeURIComponent(pfid)}` : '';

    return `/product-design/brief.aspx?xnav=DesignServices:DifyHub&service=GraphicDesign&designLivePreselected=${designLivePreSelected}${productQuery}`;
  }

  static getSocialMediaBriefURL() {
    const productName = text('digital-social-media-design');
    const pfid = 'DST-SMD';

    const productQuery = `&productName=${encodeURIComponent(productName)}&pfid=${encodeURIComponent(pfid)}`;

    return `/product-design/brief.aspx?xnav=DesignServices:DifyHub&service=GraphicDesign${productQuery}&smd=true`;
  }

  static getLogoDesignBriefURL() {
    return '/logo-design-services/brief.aspx?xnav=DesignServices:DifyHub&lopId=1';
  }

  static getLogoMakerURL() {
    return '/logoMakerService?xnav=DesignServices:DifyHub';
  }

  static getDifyWebsitesURL() {
    return '/digital/product-setup.aspx?xnav=DesignServices:DifyHub&packageGroupId=dify';
  }
}



// WEBPACK FOOTER //
// ./src/utils/DesignServicesUtil.js